import Cookies from "js-cookie";
import { PATH_AUTH } from "../router/path";
import { mainServer } from "./Api";

import Swal from "sweetalert2";
import { removeTokens } from "./auth";
import {
  errorMessage,
  successMessage,
  successMessagePro,
} from "../utils/alert";

//##########################################  Base Api  ##########################################

export const GetByID = async (queries) => {
  return (await mainServer.get(queries)).data;
};

export const GetImage = async (url) => {
  const config = { responseType: "arraybuffer" };
  return await mainServer.get(url, config);
};
export const GetFileFromServer = async (url) => {
  const config = { responseType: "arraybuffer" };
  return await mainServer.get(url, config);
};

export const Get = async (queries) => {
  return await mainServer.get(queries);
};

export const refreshToken = async (queries, data) => {
  const resp = await mainServer.get(queries, data);
  return resp.data;
};

export const GetAll = async (queries, data) => {
  return await mainServer.post(queries, data);
};

export const VerifyCallBack = async (queries) => {
  // mainServer.defaults.headers.common['X-CSRF-TOKEN'] = localStorage.getItem("token");
  return await mainServer.get(queries);
};

export const GetWithPost = async (queries, data) => {
  return await mainServer.post(queries, data);
};

export const GetSMSCode = async (queries) =>
  mainServer.get("/Secretary/Receptions/GetSmsCode", { params: queries });

export const Register = async (queries, data) => {
  return await mainServer.post(queries, data);
};
export const PaymentUser = async (queries, data) => {
  mainServer.defaults.headers.common["X-CSRF-TOKEN"] =
    Cookies.get("access_token");
  return await mainServer.post(queries, data);
};

export const RegisterByFormData = async (queries, data) => {
  mainServer.defaults.headers.post["Content-Type"] = "multipart/form-data";
  return await mainServer.postForm(queries, data);
};

export const Update = async (queries, data) => {
  return await mainServer.put(queries, data);
};

export const Delete = async (queries) => {
  return (await mainServer.delete(queries)).data;
};
export const DeleteByJSONData = async (queries, data) => {
  return await mainServer.delete(queries, data);
};
export const DeleteByData = async (queries, data) => {
  return await mainServer.delete(queries, {
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });
};

export const Remove = async (queries) =>
  mainServer.delete("/Doctor/PatientDrugs", { params: queries });

export const Search = async (queries, data) => {
  return await mainServer.post(queries, data);
};

export const Active = async (queries, data) => {
  return await mainServer.put(queries, data);
};
export const ActiveByParams = async (url, data) => {
  return await mainServer.put(url, { params: data });
};

export const ActiveByID = async (queries) => {
  return await mainServer.put("/Secretary/Appointments/Active/", {
    params: queries,
  });
};

export const Defult = async (queries, data) => {
  return await mainServer.put(queries, data);
};

export const DeleteById = async (queries) => {
  return await mainServer.delete(queries);
};
export const SMSCodeWithPost = async (queries, data) => {
  return await mainServer.post(queries, data);
};

export const Logout = async () => {
  Swal.fire({
    title: "خروج",
    text: "آیا مطمئنید که می‌خواهید از حساب کاربری خود خارج شوید؟",
    icon: "info",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "بله",
    cancelButtonText: "خیر",
  }).then(async (result) => {
    if (result.isConfirmed) {
      const ref_Token = Cookies.get("refresh_token");
      await mainServer
        .get("/Users/LogoutAll", {
          params: { refreshToken: ref_Token },
        })
        .then((res) => {
          successMessagePro("شما از تمام حساب‌های کاربری خود خارج شده‌اید");
          removeTokens();
          window.location.href = "/";
        })
        .catch((error) => {
          // پردازش خطا
          if (error.response) {
            var err = error.response.data;
            // اگر پاسخی از سمت سرور آمد، می‌توانید بازخورد سرور را بررسی کنید
            errorMessage(err.message);
            removeTokens();
            window.location.href = "/";
            //setIsLoading(false);
          } else if (error.request) {
            // اگر درخواستی برای سرور ارسال شده بود ولی پاسخی دریافت نشد
            errorMessage(error.request.message);
          } else {
            // مشکلی در هنگام پردازش درخواست پیش آمد
            errorMessage("مشکلی در هنگام پردازش درخواست پیش آمد");
            //setIsLoading(false);
          }
        });
    }
  });
};

export const LogoutUserAzHome = async () => {
  Swal.fire({
    title: "خروج",
    text: "آیا مطمئنید که می‌خواهید از حساب کاربری خود خارج شوید؟",
    icon: "info",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "بله",
    cancelButtonText: "خیر",
  }).then(async (result) => {
    if (result.isConfirmed) {
      await removeTokens();
      window.location.href = "/";
      // window.location.reload();
    }
  });
};
